import { get } from 'lodash';
import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import insertParams from 'utils/insertParams';
import { addProducts } from 'apps/products/actions/products';
import { extractAndDeleteProductsFromSections } from 'apps/products/utils/extractAndDeleteProducts';
import { SuggestedOrderFrequency } from '../../types';

const SUGGESTED_ORDER_URL = `${config.apiBasePath}/slotsub/suggested-order`;
const FREQUENCY_UPDATE_URL = `${config.apiBasePath}/slotsub/suggested-order/frequency`;

export const OR_REQUEST_SUGGESTED_ORDER = 'OR_REQUEST_SUGGESTED_ORDER';
export const OR_RECEIVE_SUGGESTED_ORDER = 'OR_RECEIVE_SUGGESTED_ORDER';
export const OR_RECEIVE_SUGGESTED_ORDER_ERROR = 'OR_RECEIVE_SUGGESTED_ORDER_ERROR';

export const OR_SHOW_MORE_SUGGESTED_ORDER_FOPS = 'OR_SHOW_MORE_SUGGESTED_ORDER_FOPS';

export const OR_SO_FREQUENCY_FILTER_UPDATE = 'OR_SO_FREQUENCY_FILTER_UPDATE';
export const OR_SO_CATEGORY_FILTER_UPDATE = 'OR_SO_CATEGORY_FILTER_UPDATE';

export const OR_REQUEST_SO_FREQUENCY_UPDATE = 'OR_REQUEST_SO_FREQUENCY_UPDATE';
export const OR_SO_FREQUENCY_UPDATE_SUCCESS = 'OR_SO_FREQUENCY_UPDATE_SUCCESS';
export const OR_SO_FREQUENCY_UPDATE_ERROR = 'OR_SO_FREQUENCY_UPDATE_ERROR';

export const OR_OPEN_CATEGORY = 'OR_OPEN_CATEGORY';

export const OR_SHOW_NAVIGATION_PAGE = 'OR_SHOW_NAVIGATION_PAGE';
export const OR_HIDE_NAVIGATION_PAGE = 'OR_HIDE_NAVIGATION_PAGE';

export function requestSuggestedOrder() {
  return {
    type: OR_REQUEST_SUGGESTED_ORDER,
  };
}

export function receiveSuggestedOrder(suggestedOrderSection, categories) {
  return {
    type: OR_RECEIVE_SUGGESTED_ORDER,
    suggestedOrderSection,
    categories,
  };
}

export function receiveSuggestedOrderError({ error }) {
  return {
    type: OR_RECEIVE_SUGGESTED_ORDER_ERROR,
    error,
  };
}

export function getSuggestedOrder() {
  return (dispatch, getState, { network }) => {
    dispatch(requestSuggestedOrder());
    const state = getState();
    const frequencyFilter = get(state, 'ordersReserved.management.suggestedOrder.frequencyFilter');
    const categoryFilter = get(state, 'ordersReserved.management.suggestedOrder.categoryFilter');
    const suggestedOrderUrl = insertParams(SUGGESTED_ORDER_URL, {
      frequency: frequencyFilter === SuggestedOrderFrequency.ALL ? null : frequencyFilter,
      categoryId: categoryFilter,
    }, true);
    return network.get(suggestedOrderUrl)
      .then((data) => {
        const products = extractAndDeleteProductsFromSections(get(data, 'fopCollection.sections', []));
        dispatch(receiveSuggestedOrder(get(data, 'fopCollection.sections.0', null), data.categories || []));
        dispatch(addProducts(products));
      })
      .catch(err => {
        dispatch(receiveSuggestedOrderError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function showMoreFops() {
  return {
    type: OR_SHOW_MORE_SUGGESTED_ORDER_FOPS,
  };
}

export function frequencyFilterUpdate(frequency) {
  return {
    type: OR_SO_FREQUENCY_FILTER_UPDATE,
    frequency,
  };
}

export function changeFrequencyFilter(frequency) {
  return (dispatch) => {
    dispatch(frequencyFilterUpdate(frequency));
    return dispatch(getSuggestedOrder());
  };
}

export function categoryFilterUpdate(categoryId) {
  return {
    type: OR_SO_CATEGORY_FILTER_UPDATE,
    categoryId,
  };
}

export function changeCategoryFilter(categoryId) {
  return (dispatch) => {
    dispatch(categoryFilterUpdate(categoryId));
    return dispatch(getSuggestedOrder());
  };
}

export function requestFrequencyUpdate(sku) {
  return {
    type: OR_REQUEST_SO_FREQUENCY_UPDATE,
    sku,
  };
}

export function frequencyUpdateSuccess({ sku, frequency }) {
  return {
    type: OR_SO_FREQUENCY_UPDATE_SUCCESS,
    sku,
    frequency,
  };
}

export function frequencyUpdateError({ error }, sku) {
  return {
    type: OR_SO_FREQUENCY_UPDATE_ERROR,
    error,
    sku,
  };
}

export function updateFrequency({ sku, frequency }) {
  return (dispatch, getState, { network }) => {
    dispatch(requestFrequencyUpdate(sku));
    return network
      .put(FREQUENCY_UPDATE_URL, {
        body: JSON.stringify({ sku, frequency }),
      })
      .then(() => dispatch(frequencyUpdateSuccess({ sku, frequency })))
      .catch(err => {
        dispatch(frequencyUpdateError(err.data || UNKNOWN_ERROR, sku));
      });
  };
}

export function openCategory(categoryId) {
  return {
    type: OR_OPEN_CATEGORY,
    categoryId,
  };
}

export function showNavigationPage() {
  return {
    type: OR_SHOW_NAVIGATION_PAGE,
  };
}

export function hideNavigationPage() {
  return {
    type: OR_HIDE_NAVIGATION_PAGE,
  };
}

